import { useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Skeleton,
  Card,
  Breadcrumb,
  Pagination,
} from "antd";
import { F3 } from "../../../assets";
import CustomHeader2 from "../../landingpage/Header/CustomHeader2";
import { Footers } from "../../Footers";
import { useHttp } from "../../../utils/DataHendler";
import { useNavigate } from "react-router-dom";
import { AppstoreOutlined, HomeOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../../context/Language.contex";

const { Title } = Typography;

const EventPage = () => {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  const [data, setData] = useState([]);
  const { getData } = useHttp();
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 12,
    total: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchData = async (queryParams) => {
    setLoading(true);
    try {
      const response = await getData(`/event`, { params: queryParams }, false);
      if (response.success) {
        const structuredData = response.data.data.map((item) => ({
          ...item,
          key: item.id,
        }));

        setData(structuredData);
        setPagination({
          page: response.data.pagination.page,
          limit: response.data.pagination.limit,
          total: response.data.pagination.total,
          totalPages: response.data.pagination.totalPages,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    fetchData({ ...filters, page: newPage, limit: pagination.limit });
  };

  useEffect(() => {
    fetchData({ page: pagination.page, limit: pagination.limit });
  }, []);

  return (
    <div>
      <CustomHeader2 />

      {/* Header with grayscale fade and breadcrumb */}
      <div style={{ position: "relative", height: "350px" }}>
        <div
          style={{
            backgroundImage: `url('${F3}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "grayscale(5%)",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2,
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 3,
            padding: "15px 0 0 15px",
          }}
        >
          {/* <Breadcrumb style={{ color: "#fff" }}>
              <Breadcrumb.Item>
                <a
                  style={{ color: "#fff" }}
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Home
                </a>
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#fff" }}>Career</Breadcrumb.Item>
            </Breadcrumb> */}
        </div>
        <div
          style={{
            position: "relative",
            zIndex: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Title
            style={{
              color: "#fff",
              fontSize: "3rem",
              textShadow: "0 0 10px rgba(0,0,0,0.5)",
              margin: 0,
            }}
          >
            {language[15]}
          </Title>
        </div>
      </div>

      {/* Career List */}
      <div style={{ padding: "24px 48px" }}>
        <Row gutter={[24, 24]}>
          {loading
            ? Array.from({ length: pagination.limit }).map((_, idx) => (
                <Col xs={24} sm={12} md={8} lg={6} key={idx}>
                  <Card
                    cover={
                      <Skeleton.Image
                        active
                        style={{ width: "100%", height: 200 }}
                      />
                    }
                  >
                    <Skeleton
                      active
                      paragraph={{ rows: 2 }}
                      title={{ width: "80%" }}
                    />
                  </Card>
                </Col>
              ))
            : data.length > 0
            ? data.map((evnt) => (
                <Col xs={24} sm={12} md={8} lg={6} key={evnt.id}>
                  <Card
                    hoverable
                    onClick={() => {
                      navigate(`/event/${evnt.id}`);
                    }}
                    cover={
                      <img
                        alt={evnt.title}
                        src={
                          evnt.top_image ||
                          "https://via.placeholder.com/300x200"
                        }
                        style={{
                          width: "100%",
                          height: 180,
                          objectFit: "cover",
                          borderTopLeftRadius: 14,
                          borderTopRightRadius: 14,
                        }}
                      />
                    }
                    style={{
                      borderRadius: 14,
                      boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
                      minHeight: 320,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      padding: 0,
                      overflow: "hidden",
                      cursor: "pointer",
                      background: "#fff",
                      position: "relative", // penting untuk absolute date
                    }}
                    bodyStyle={{
                      padding: "18px 16px 16px 16px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      flex: 1,
                    }}
                  >
                    {/* Tanggal di pojok kanan bawah */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: 12,
                        right: 16,
                        background: "rgba(0,0,0,0.7)",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: 8,
                        fontSize: 13,
                        zIndex: 2,
                        fontWeight: 500,
                        letterSpacing: 0.5,
                      }}
                    >
                      {evnt.created_at}
                    </div>
                    <Title
                      level={5}
                      style={{
                        marginBottom: 8,
                        fontWeight: 600,
                        fontSize: 18,
                        color: "#222",
                        textAlign: "left",
                        lineHeight: 1.3,
                      }}
                    >
                      {evnt.title}
                    </Title>
                  </Card>
                </Col>
              ))
            : !loading && (
                <Col
                  span={24}
                  style={{ textAlign: "center", padding: "40px 0" }}
                >
                  <Title level={4}>Belum ada career</Title>
                </Col>
              )}
        </Row>

        {/* Pagination */}
        {!loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 40,
              paddingRight: "5vw",
              marginBottom: 64,
            }}
          >
            <Pagination
              current={pagination.page}
              total={pagination.total}
              pageSize={pagination.limit}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        )}
      </div>

      <Footers />
    </div>
  );
};

export default EventPage;
